<template>
  <div>
    <customize-page
      label-position="left"
      ref="page"
      inline
      :loading="loading"
      :data="dataList"
      :columns="columns"
      :pagination="pagination"
      :formConfig="getFormConfig()"
      :filterObj="filterObj"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
      <div slot="footer">
        <el-button style="margin-right: 10px" type="primary" @click="search">
          搜索
        </el-button>
        <el-button style="margin-right: 10px" @click="reset">重置</el-button>
      </div>
    </customize-page>
  </div>
</template>

<script>
import CustomizePage from "@/components/customize-page";
import Page from "@/mixin/Page";

import { mapActions } from "vuex";

export default {
  components: {
    CustomizePage,
  },
  mixins: [Page],
  created() {
    this.defaultFormData = JSON.stringify(this.formData);
  },
  mounted() {
    this.fetch();
  },
  data() {
    return {
      loading: false,
      dataList: [],
      columns: [
        {
          type: "selection",
          width: 50,
          align: "center",
          fixed: "left",
        },
        {
          title: "商品名",
          "min-width": 200,
          key: "productName",
          align: "center",
        },
        {
          title: "帐册编号",
          width: 160,
          key: "CustomerID",
          align: "center",
        },
        {
          title: "仓库ID",
          "min-width": 100,
          key: "WarehouseID",
          align: "center",
        },
        {
          title: "SKU",
          width: 100,
          key: "SKU",
          align: "center",
        },
        {
          title: "总库存",
          width: 100,
          key: "Qty",
          align: "center",
          render: (h, param) => {
            let row = param.row;
            let result = 0;
            if (row.Qty != null) {
              result = parseInt(row.Qty);
            }
            return <span>{result}</span>;
          },
        },
        {
          title: "品质",
          width: 60,
          key: "quality",
          align: "center",
        },
        {
          title: "可用库存",
          "min-width": 100,
          key: "availableStock",
          align: "center",
          render: (h, param) => {
            let row = param.row;
            let result = 0;
            if (row.availableStock != null) {
              result = parseInt(row.availableStock);
            }
            return <span>{result}</span>;
          },
        },
        {
          title: "不可用库存",
          "min-width": 100,
          key: "disableStock",
          align: "center",
          render: (h, param) => {
            let row = param.row;
            let result = 0;
            if (row.disableStock != null) {
              result = parseInt(row.disableStock);
            }
            return <span>{result}</span>;
          },
        },
      ],
      filterObj: {
        SKU: "",
      },
      currentRow: [],
      sortObj: {},
    };
  },
  computed: {},
  methods: {
    ...mapActions("fss", {
      list: "querySkuStock",
    }),
    // 更新品牌列表
    fetch() {
      this.loading = true;
      const filterParams = this.getFilterParams();
      const sortObj = this.sortObj;
      let searchCondition = {
        ...sortObj,
        request: JSON.stringify({
          ...filterParams,
          pageIndex: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
        }),
      };

      this.list(searchCondition)
        .then((res) => {
          this.loading = false;
          this.dataList = res.items || [];
          this.pagination.pageSize = this.pagination.totalCount = res.total;
        })
        .catch((error) => {
          this.loading = false;
          this.$message.error("异常");
        });
    },
    getFormConfig() {
      const type = this.getFormItemType();
      return [
        {
          data: [
            {
              label: "SKU",
              model: "SKU",
              type: type.INPUT,
            },
          ],
        },
      ];
    },
  },
};
</script>
